export const info = "i7llze6";
export const container = "che4464";
export const gridContainer = "g1nz15u5";
export const imageContainer = "i1b3i0y5";
export const image = "ibc2mb9";
export const sectionTitle = "sci98pj";
export const guideTitle = "gtcqacn";
export const classTitle = "c1n9clw2";
export const avatar = "avfhl1h";
export const byline = "bd0izg7";
export const badge = "b177drd1";
export const notesBadge = "n1npmwpk";
export const imageDescriptor = "i183l5js";
export const feedbackContainer = "fbcihjd";
export const feedbackLink = "f1lvo4cd";

require("./style.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");